import "./btn.css"

import React, { forwardRef } from "react"

import { BaseButton, BaseButtonElementProps } from "./BaseButton"

export type ButtonElementProps = Omit<BaseButtonElementProps, "label"> & {
  /** The text content of the button. */
  label: string
}

/**
 * A button component that renders as a button element.
 * Supports various sizes, styles, and content types.
 * Label must be a string.
 *
 * @component
 */
export const Button = forwardRef<HTMLButtonElement, ButtonElementProps>(
  (props, ref) => {
    return <BaseButton {...props} ref={ref} />
  }
)

Button.displayName = "Button"
